import styled from "styled-components";
import monitorMaskImage from './assets/mask.png'
import noiseImage from './assets/noise.svg'
import cursorImage from './assets/cursor.png'

export default styled.div`
    display: flex;
    position: absolute;
    box-sizing: border-box;
    width: 520px;
    height: 400px;
    background-color: #1a140d;
    z-index: 22215;
    filter: contrast(170%) brightness(100%);
    cursor: url('${cursorImage}'), auto;
    transform: 
      translate(16px, -286px)
      translateZ(100px)
      rotateX(359deg)
      rotateY(-14deg)
      rotateZ(2.3deg)
      skewX(0deg)
      scale(1.07, 1.04);
    background-image:
      radial-gradient(ellipse at 75% 40%, #8063224f, #00000000 50%),
      linear-gradient(0deg, #00000050, #00000000 15%),
      linear-gradient(90deg, #00000050, #00000000 16%),
      linear-gradient(180deg, #00000050, #00000000 17%),
      linear-gradient(270deg, #00000050, #00000000 10%),
      radial-gradient(#835f37, #58442df5 50%, #352210 100%),
      url(${noiseImage});
    background-position: -16px 2px;
    mask: url(${monitorMaskImage});
    transform-origin: 50% 50%;

`
